import { createElement, useCallback, useState } from 'react';
import { Input, Icon } from '@alifd/next';
import cls from 'classnames/bind';
import style from './index.module.scss';
const cx = cls.bind(style);
const RangeQuery = (props) => {
    const { value, onChange } = props;
    const [greater, setGreater] = useState('');
    const [less, setLess] = useState('');
    const rangeEmit = useCallback((type, val) => {
        let gre = greater;
        let le = less;
        if (type === 'greater') {
            gre = val;
            setGreater(val);
        }
        else {
            le = val;
            setLess(val);
        }
        onChange(`${gre},${le}`);
    }, [greater, less]);
    return (createElement("div", { className: cx('rangeQuery') },
        createElement(Input, { placeholder: "\u67E5\u8BE2\u4E0B\u9650", style: { flex: 1, width: '40%' }, value: greater, onChange: val => rangeEmit('greater', val) }),
        createElement(Icon, { type: "minus", size: 'xxs', style: { color: '#999999' } }),
        createElement(Input, { placeholder: "\u67E5\u8BE2\u4E0A\u9650", style: { flex: 1, width: '40%' }, value: less, onChange: val => rangeEmit('less', val) })));
};
export default RangeQuery;
